import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Box, Card, Heading, Spinner, Text, Button, Table, Thead, Tbody, Tr, Th, Td, Badge } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import Axios from '../utils/httpClient';
import Layout from './Layout';
import { kpiSections } from './kpiData';

const PRIMARY = '#133654';

const TeachersWithPoints = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameterCode = searchParams.get('parameter_code');

  const [loading, setLoading] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [parameter, setParameter] = useState(null);

  // Find the parameter details
  useEffect(() => {
    if (parameterCode) {
      const allParameters = kpiSections.flatMap(s => s.items);
      const foundParam = allParameters.find(p => String(p.no) === String(parameterCode));
      setParameter(foundParam);
    }
  }, [parameterCode]);

  // Load teachers with points
  useEffect(() => {
    if (!parameterCode) return;

    setLoading(true);
    Axios().get(`api/v1/application/teachers-with-points/`, {
      params: { parameter_code: parameterCode }
    })
      .then(res => {
        setTeachers(res?.data?.teachers || []);
      })
      .catch(e => {
        console.error('Error loading teachers with points:', e);
        setTeachers([]);
      })
      .finally(() => setLoading(false));
  }, [parameterCode]);

  return (
    <Layout showLoginButton={true}>
      <Box p={4}>
        <Button
          onClick={() => navigate(-1)}
          mb={3}
          color="white"
          bg="#133654"
          _hover={{ bg: "#133654" }}
        >
          <ArrowBackIcon />
          <span style={{ marginLeft: 5 }}>Orqaga</span>
        </Button>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Heading size="md">
            {parameter ? `${parameter.no} - ${parameter.parameter}` : `Parametr ${parameterCode}`}
          </Heading>
        </Box>

        <Card style={{ padding: 16, marginBottom: 16 }}>
          {parameter && (
            <>
              <Text fontWeight={600} mb={2}>Mexanizm</Text>
              <Text whiteSpace="pre-wrap">{parameter.mechanism}</Text>
              <Text mt={3}><b>Maks. ball:</b> {parameter.maxBall}</Text>
            </>
          )}
        </Card>

        <Card style={{ padding: 16 }}>
          <Heading size="sm" mb={4}>
            {loading
              ? "O'qituvchilar yuklanmoqda..."
              : `Baholangan o'qituvchilar (${teachers.length} ta)`
            }
          </Heading>

          {loading ? (
            <Box display="flex" justifyContent="center" p={8}>
              <Spinner size="xl" color={PRIMARY} />
            </Box>
          ) : teachers.length === 0 ? (
            <Text color="gray.600">Bu parametr bo'yicha baholangan o'qituvchilar topilmadi</Text>
          ) : (
            <Table variant="simple" size="sm">
              <Thead>
                <Tr bg="gray.50">
                  <Th width="60px">No</Th>
                  <Th>O'qituvchi</Th>
                  <Th width="120px" textAlign="right">Jami ball</Th>
                </Tr>
              </Thead>
              <Tbody>
                {teachers.map((teacher, index) => (
                  <Tr 
                    key={teacher.id} 
                    _hover={{ bg: 'gray.100', cursor: 'pointer' }}
                    onClick={() => navigate('/login')}
                  >
                    <Td>
                      <Badge
                        colorScheme={teacher.rank === 1 ? 'yellow' : teacher.rank === 2 ? 'gray' : teacher.rank === 3 ? 'orange' : 'blue'}
                        fontSize="md"
                        px={3}
                        py={1}
                        borderRadius="full"
                      >
                        {teacher.rank}
                      </Badge>
                    </Td>
                    <Td>
                      <Text fontWeight={600}>
                        {teacher.last_name} {teacher.first_name} {teacher.middle_name || ''}
                      </Text>
                      <Text fontSize="xs" color="gray.600">{teacher.kafedra_name || teacher.username}</Text>
                    </Td>
                    <Td textAlign="right">
                      <Text fontWeight={700} fontSize="lg" color={PRIMARY}>
                        {teacher.parameter_points.toFixed(2)}
                      </Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Card>
      </Box>
    </Layout>
  );
};

export default TeachersWithPoints;